import { render, staticRenderFns } from "./ParamScaleMainList.vue?vue&type=template&id=cb926476&scoped=true"
import script from "./ParamScaleMainList.vue?vue&type=script&lang=js"
export * from "./ParamScaleMainList.vue?vue&type=script&lang=js"
import style0 from "./ParamScaleMainList.vue?vue&type=style&index=0&id=cb926476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb926476",
  null
  
)

export default component.exports